import { wrapRootBrowser } from './src/apollo/wrap-root';

export const wrapRootElement = wrapRootBrowser;
